<template>
    <div>
        <h2>User Register</h2>
        <form @submit.prevent="submitForm">
            <div>
                <label for="username">账户:</label>
                <input type="text" id="username" v-model="username" @input="validateUsername" />
                <p v-if="usernameError" class="error">{{ usernameError }}</p>
            </div>
            <div>
                <label for="password">密码:</label>
                <input type="password" id="password" v-model="password" @input="validatePassword" />
                <p v-if="passwordError" class="error">{{ passwordError }}</p>
            </div>
            <div>
                <label for="phone">电话:</label>
                <input type="text" id="phone" v-model="phone" @input="validatePhone" />
                <p v-if="phoneError" class="error">{{ phoneError }}</p>
            </div>
            <button type="submit" :disabled="isSubmitting">注册</button>
        </form>
    </div>
</template>

<script>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';

    export default {
        name: 'RegisterForm',
        setup () {
            const username = ref('');
            const password = ref('');
            const phone = ref('');
            const usernameError = ref('');
            const passwordError = ref('');
            const phoneError = ref('');
            const isSubmitting = ref(false);
            const router = useRouter();

            // 验证函数(通用验证逻辑)
            const validateInput = (input, error, emptyErrorMsg, lengthErrorMsg, maxLength, regex, regexErrorMsg) => {
                if (input.value === '') {
                    error.value = emptyErrorMsg;
                } else if (input.value.length > maxLength) {
                    error.value = lengthErrorMsg;
                } else if (regex && !regex.test(input.value)) {
                    error.value = regexErrorMsg;
                } else {
                    error.value = '';
                }
            };

            // 验证用户名函数
            const validateUsername = () => {
                validateInput(username, usernameError, '用户名不能为空.', '用户名不应超过10个字符.', 10);
            };

            // 验证密码函数
            const validatePassword = () => {
                validateInput(password, passwordError, '密码不能为空.', '密码不应超过20个字符.', 20);
            };

            // 验证电话号码函数
            const validatePhone = () => {
                const phoneRegex = /^\d{11}$/; // 电话号码是11位数字  
                validateInput(phone, phoneError, '电话号码不能为空.', '', 0, phoneRegex, '请输入有效的11位电话号码.');
            };

            // 提交表单时
            const submitForm = async () => {
                try {
                    // 调用所有验证函数进行验证
                    validateUsername();
                    validatePassword();
                    validatePhone();

                    // 检查是否有输入错误
                    if (usernameError.value || passwordError.value || phoneError.value) {
                        throw new Error('输入有误');
                    }

                    // 设置提交状态为true（按钮变为禁用状态），开始显示加载指示器等
                    isSubmitting.value = true; //作用是确保用户在表单提交期间不会重复提交，同时提供了更好的用户体验，通过UI的反馈告知用户表单正在处理中
                    
                    // 所有前端验证都通过，请求API来注册用户
                    const response = await fetch('/api/register', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            username: username.value,
                            password: password.value,
                            phone: phone.value,
                        }),
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        throw new Error(data.message || '注册失败');
                    }

                    if (data.success) {
                        alert('注册成功!');
                        // 清除表单  
                        username.value = '';
                        password.value = '';
                        phone.value = '';
                        router.push('/');
                    } else {
                        throw new Error('注册失败：' + data.message);
                    }
                } catch (error) {
                    console.error('注册过程中出错：', error);
                    alert('注册过程中发生错误：' + error.message);
                } finally {
                    // 无论请求成功或失败，最后都将提交状态设置为false（按钮重新变得可点击），并隐藏加载指示器等
                    isSubmitting.value = false;
                }
            };

            return {
                username,
                password,
                phone,
                usernameError,
                passwordError,
                phoneError,
                isSubmitting,
                validateUsername,
                validatePassword,
                validatePhone,
                submitForm,
            };
        },
    };
</script>

<style scoped>
    .error {
        color: red;
    }
</style>